import { prefersReducedMotion } from '@theme/utilities';

class RuneReveal extends HTMLElement {
  /** @type {IntersectionObserver | null} */
  #observer = null;

  connectedCallback() {
    if (prefersReducedMotion()) {
      this.classList.add('is-visible');
      return;
    }

    this.#observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          this.classList.add('is-visible');
          this.#observer?.disconnect();
        }
      },
      { threshold: 0.35 }
    );
    this.#observer.observe(this);

    this.addEventListener('pointermove', this.#handlePointerMove);
    this.addEventListener('pointerleave', this.#handlePointerLeave);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.removeEventListener('pointermove', this.#handlePointerMove);
    this.removeEventListener('pointerleave', this.#handlePointerLeave);
  }

  /**
   * @param {PointerEvent} event
   */
  #handlePointerMove = (event) => {
    if (prefersReducedMotion()) return;

    const rune = this.querySelector('.rune-reveal__rune');
    if (!(rune instanceof HTMLElement)) return;

    const rect = this.getBoundingClientRect();
    const x = (event.clientX - rect.left) / rect.width - 0.5;
    const y = (event.clientY - rect.top) / rect.height - 0.5;

    rune.style.transform = `rotate3d(${-y}, ${x}, 0, 8deg)`;
  };

  #handlePointerLeave = () => {
    const rune = this.querySelector('.rune-reveal__rune');
    if (rune instanceof HTMLElement) rune.style.transform = '';
  };
}

if (!customElements.get('rune-reveal')) customElements.define('rune-reveal', RuneReveal);
